var styles = {
raw: ".hcr-divider-8-6-0{background-color:var(--hcr-line-primary-color);border-style:none;height:1px}",
map:{"hcr-divider":"hcr-divider-8-6-0"}};

export { styles as default };
